// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2GbEb","colMin":"styles_colMin__Ofu62","colCheckbox":"styles_colCheckbox__2q17X"};